import { APITypes } from '../../primary-record-types';
import { getIntl } from '../../utils/intl';
import { getMedicalProfileOwnerCacheKey } from './cacheKeys';
import { appAPI } from '../../utils/api';
import urls from '../../utils/urls';
import { useQuery } from '@tanstack/react-query';
import { useQueryErrorNotify } from '../useQueryCallbacks';

const intl = getIntl('useMedicalProfileOwner', {
    errorLoadingProfileOwner: 'Error loading profile owner',
});

export type UseMedicalProfileOwnerArgs = {
    medicalProfileId: string;
};

export type UseMedicalProfileOwnerReturnValue = {
    isLoading: boolean;
    owner: APITypes.medicalProfileService.GetMedicalProfileOwnerResponse | null;
};

export default function useMedicalProfileOwner({
    medicalProfileId,
}: UseMedicalProfileOwnerArgs): UseMedicalProfileOwnerReturnValue {
    const ownerQuery = useQuery<APITypes.medicalProfileService.GetMedicalProfileOwnerResponse | null>({
        queryKey: getMedicalProfileOwnerCacheKey(medicalProfileId),
        queryFn: async () => {
            return await appAPI.get(urls.api.medicalProfiles.owner.owner(medicalProfileId), {
                ignoreErrorStatus: [404],
            });
        },
    });
    useQueryErrorNotify(ownerQuery, intl('errorLoadingProfileOwner'));

    return {
        isLoading: ownerQuery.isLoading,
        owner: ownerQuery.data || null,
    };
}
